/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { ReactNode, useEffect } from "react";
import PropTypes from "prop-types";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import "typeface-noto-sans";

import Header from "./header";
import Footer from "./footer";
import "./layout.css";
import { Helmet } from "react-helmet";

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      "noto-sans",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

interface LayoutProps {
  language: string;
  children: React.ReactNode;
}

function Layout (props: LayoutProps) {
  useEffect(()=> {
    import('scrollreveal').then(({ default: ScrollReveal }) => {
      const sr = ScrollReveal()
      sr.reveal('.reveal', {
        delay: 500,
        distance: '150%',
        origin: 'bottom',
      });
    });
  }, [])
 
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        {/* <!-- OneTrust Cookies Consent Notice start for hyperconnect.com --> */}
        <script type="text/javascript" src="https://cdn.cookielaw.org/consent/855c5baf-4c2c-4590-8da2-b3d9d61013eb/OtAutoBlock.js"></script>
        <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" data-document-language="true" type="text/javascript" charSet="UTF-8" data-domain-script="855c5baf-4c2c-4590-8da2-b3d9d61013eb"></script>
        <script type="text/javascript">{`function OptanonWrapper() {}`}</script>
        {/* <!-- OneTrust Cookies Consent Notice end for hyperconnect.com --> */}
      </Helmet>
      <Header language={props.language} />
      <div>{props.children}</div>
      <Footer language={props.language} />
    </ThemeProvider>
  );
}

export default Layout;
